// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { CommandRule, CommandRuleT, verifyCommandRule } from "./command-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { Origin } from "./origin";
import { OutRule, unionToOutRule, unionListToOutRule } from "./out-rule";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";

/**
 * One LN2 control and the MCE commands it becomes.
 *
 * `match` is the index of a template whose message names the control; the
 * template's `fill` names the parts read from the incoming control instead
 * of matched.
 */
export class ControlRow implements flatbuffers.IUnpackableObject<ControlRowT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControlRow {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControlRow(bb: flatbuffers.ByteBuffer, obj?: ControlRow): ControlRow {
    return (obj || new ControlRow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsControlRow(bb: flatbuffers.ByteBuffer, obj?: ControlRow): ControlRow {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControlRow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  match(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  ruleType(): OutRule {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : OutRule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  origin(): Origin {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Origin.Unmapped;
  }

  profileRow(): string | null;
  profileRow(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  profileRow(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startControlRow(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addMatch(builder: flatbuffers.Builder, match: number) {
    builder.addFieldInt32(0, match, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: OutRule) {
    builder.addFieldInt8(1, ruleType, OutRule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, ruleOffset, 0);
  }

  static addOrigin(builder: flatbuffers.Builder, origin: Origin) {
    builder.addFieldInt8(3, origin, Origin.Unmapped);
  }

  static addProfileRow(builder: flatbuffers.Builder, profileRowOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, profileRowOffset, 0);
  }

  static endControlRow(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // rule
    return offset;
  }

  static createControlRow(
    builder: flatbuffers.Builder,
    match: number,
    ruleType: OutRule,
    ruleOffset: flatbuffers.Offset,
    origin: Origin,
    profileRowOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ControlRow.startControlRow(builder);
    ControlRow.addMatch(builder, match);
    ControlRow.addRuleType(builder, ruleType);
    ControlRow.addRule(builder, ruleOffset);
    ControlRow.addOrigin(builder, origin);
    ControlRow.addProfileRow(builder, profileRowOffset);
    return ControlRow.endControlRow(builder);
  }

  unpack(): ControlRowT {
    return new ControlRowT(
      this.match(),
      this.ruleType(),
      (() => {
        const temp = unionToOutRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.origin(),
      this.profileRow(),
    );
  }

  unpackTo(_o: ControlRowT): void {
    _o.match = this.match();
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToOutRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.origin = this.origin();
    _o.profileRow = this.profileRow();
  }

  unpackFields(...fields: string[]): ControlRowT {
    const t = new ControlRowT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("match")) {
      t.match = this.match();
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToOutRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("origin")) {
      t.origin = this.origin();
    }
    if (fieldSet.has("profile_row")) {
      t.profileRow = this.profileRow();
    }
    return t;
  }
}

export class ControlRowT implements flatbuffers.IGeneratedObject {
  constructor(
    public match: number = 0,
    public ruleType: OutRule = OutRule.NONE,
    public rule: CommandRuleT | IgnoreRuleT | TransformRuleT | null = null,
    public origin: Origin = Origin.Unmapped,
    public profileRow: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const rule = builder.createObjectOffset(this.rule);
    const profileRow = this.profileRow !== null ? builder.createString(this.profileRow!) : 0;

    return ControlRow.createControlRow(
      builder,
      this.match,
      this.ruleType,
      rule,
      this.origin,
      profileRow,
    );
  }

  clone(): ControlRowT {
    const obj = new ControlRowT();
    obj.match = this.match;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.origin = this.origin;
    obj.profileRow = this.profileRow;
    return obj;
  }

  equals(other: ControlRowT): boolean {
    if (this.match !== other.match) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.origin !== other.origin) return false;
    if (this.profileRow !== other.profileRow) return false;
    return true;
  }
}

export function verifyControlRow(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // CommandRule
            {
              const o = verifier.readInt32(pos);
              verifyCommandRule(verifier, pos + o);
            }
            break;
          case 3: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "rule");
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
